/**
 * Shared constants and helpers for block-expiry logic (e.g. BlockExpiredModal when invitee is older than 90 days).
 * Used by invitee_details and invitee_actions so the threshold and check stay in sync.
 */

const NINETY_DAYS_MS = 90 * 24 * 60 * 60 * 1000

/**
 * @param {string | undefined} createdAt - ISO date string (e.g. invitee.createdAt)
 * @returns {boolean} true if createdAt is more than 90 days ago
 */
export const isInviteeOlderThan90Days = (createdAt) => Boolean(createdAt && (Date.now() - new Date(createdAt).getTime()) > NINETY_DAYS_MS)
